import { render, staticRenderFns } from "./ReceiptOrNot.vue?vue&type=template&id=62e2a1f8&scoped=true&"
import script from "./ReceiptOrNot.vue?vue&type=script&lang=js&"
export * from "./ReceiptOrNot.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptOrNot.vue?vue&type=style&index=0&id=62e2a1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e2a1f8",
  null
  
)

export default component.exports